/**
 * Manos F7-P1 — sitewide alert ribbon. Slim, dismissible, links to the Centro de Crisis
 * (F1 at /venezuela, same origin). Visible-face policy (D8): QUUL framing only — no
 * MayiLabs, no in-zone individual, no casualty figures (enforced by the manos i18n copy).
 */
import { useState } from 'react';
import { X } from 'lucide-react';
import type { Translations } from '../../types';

const CRISIS_HREF = '/venezuela';

export function ManosRibbon({ t }: { t: Translations }) {
  const [dismissed, setDismissed] = useState(false);
  if (dismissed) return null;

  return (
    <div
      data-testid="manos-ribbon"
      role="region"
      aria-label={t.manos.navItem}
      className="bg-vinotinto text-white"
    >
      <div className="max-w-7xl mx-auto px-4 py-2 flex items-center justify-between gap-3 text-sm">
        <a href={CRISIS_HREF} className="flex-1 hover:underline">
          {t.manos.ribbonText} <span className="font-semibold underline">{t.manos.ribbonCta}</span>
        </a>
        <button
          type="button"
          onClick={() => setDismissed(true)}
          aria-label={t.manos.ribbonDismiss}
          className="shrink-0 p-1 rounded hover:bg-white/10 transition-colors"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
